import {
  BookingContext,
  BookingIntent,
  BookingPosition,
  BookingServices,
  StockTargetType,
  SystemContext,
} from '../types';
import { BookingRequest } from './booking-request';
import { BookingOrchestrator } from '../booking-orchestrator';

export abstract class FromBuilder {
  /**
   * @param orchestrator Kernel, das die einzelnen Position-Buchungen ausführt
   * @param systemContext System-weite Konfiguration aus den Funktionsschaltern
   * @param bookingContext Bisher gesammelter Kontext (`sourceType`, `sourceId` gesetzt)
   * @param services Von der App injizierte Model- und Warehouse-Services
   * @param positions Liste der zu buchenden Positionen (vom `SourceBuilder` durchgereicht)
   */
  constructor(
    protected readonly orchestrator: BookingOrchestrator,
    protected readonly systemContext: SystemContext,
    protected readonly bookingContext: Partial<BookingContext>,
    protected readonly services: BookingServices,
    protected readonly positions: BookingPosition[],
  ) {}

  /**
   * Übergang in die nächste Stage für Buchungen mit Ziel-Lager.
   *
   * @param targetStock Typ des Ziel-Lagers
   * @param targetId ID des Ziel-Lagers
   * @param intent Fachliche Absicht der Buchung
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  protected next(
    targetStock: StockTargetType,
    targetId: number,
    intent: BookingIntent,
  ): BookingRequest {
    return new BookingRequest(
      this.orchestrator,
      this.systemContext,
      { ...this.bookingContext, targetType: targetStock, targetId, intent },
      this.services,
      this.positions,
    );
  }

  /**
   * Übergang in die nächste Stage für Disposal-Buchungen ohne Ziel-ID.
   *
   * @param targetStock Typ des Disposal-Ziels (z.B. TRASH_BIN, CONSUMPTION_BIN)
   * @param intent Fachliche Absicht der Buchung
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  protected nextDisposal(
    targetStock: StockTargetType,
    intent: BookingIntent,
  ): BookingRequest {
    return new BookingRequest(
      this.orchestrator,
      this.systemContext,
      { ...this.bookingContext, targetType: targetStock, intent },
      this.services,
      this.positions,
    );
  }
}
